import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-solid-svg-icons';

const Footer = (): JSX.Element => {
  const year = new Date().getFullYear();
  return (
    <div className="app-footer">
      <span style={{ marginRight: '5px' }}>Copyright</span>
      <FontAwesomeIcon icon={faCopyright} />
      <span style={{ marginLeft: '5px' }}>{year}</span>
    </div>
  );
};

export default Footer;
